export default __webpack_public_path__ + "static/media/expl-dissect_03_DE.9057d284.png";